import React, { useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { usePermissions } from "./PermissionContext";
import { hasAnyAccessiblePermission } from "../application-landing/constants";
import {
  ROLE_ENTITLED_PERMISSIONS,
  hasFacilityRole,
} from "./roleEntitlements";

const RestrictedRoute = ({
  permission,
  permissionAnyOf = [],
  allowedRoles = [],
  children,
  ...rest
}) => {
  const { permissions = [], loading, userInfo } = usePermissions();
  const location = useLocation();
  const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";
  const roleType = String(
    userInfo?.role_permission?.[0]?.role ||
      sessionStorage.getItem("roleType") ||
      "",
  )
    .trim()
    .toLowerCase();
  const roleAllowed = allowedRoles.some(
    (r) => String(r || "").trim().toLowerCase() === roleType,
  );
  const hasPermission = permissions.some(
    (p) => p.permission_name === permission && p.is_accessible,
  );
  const hasAnyPermission =
    Array.isArray(permissionAnyOf) &&
    permissionAnyOf.length > 0 &&
    hasAnyAccessiblePermission(permissions, permissionAnyOf);
  // Matches the landing page's role-based entitlement, so a tile shown there
  // never lands on Access Denied.
  const isRoleEntitled =
    ROLE_ENTITLED_PERMISSIONS.includes(permission) &&
    hasFacilityRole(
      userInfo?.role_permission?.[0]?.role,
      sessionStorage.getItem("roleType"),
    );
  const hasAccess =
    roleAllowed || hasPermission || hasAnyPermission || isRoleEntitled;

  // Keep hooks before any early return.
  useEffect(() => {
    if (!loading && (hasAccess || isSuperAdmin)) {
      sessionStorage.setItem(
        "lastAccessiblePath",
        `${location.pathname}${location.search || ""}`,
      );
    }
  }, [loading, hasAccess, isSuperAdmin, location.pathname, location.search]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isSuperAdmin) {
    return <Route {...rest}>{children}</Route>;
  }

  return (
    <Route
      {...rest}
      render={() =>
        hasAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/AccessDeniedPage",
              state: {
                deniedPath: `${location.pathname}${location.search || ""}`,
                fallbackPath:
                  sessionStorage.getItem("lastAccessiblePath") || "/login",
              },
            }}
          />
        )
      }
    />
  );
};

export default RestrictedRoute;
